var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-purchase-check-update" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 24 : 12 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "add-form",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "divider-title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ]),
                      _c("el-divider")
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "油站：" }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.formData.stationName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "stationName", $$v)
                                  },
                                  expression: "formData.stationName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "油品：" }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.formData.oilCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "oilCode", $$v)
                                  },
                                  expression: "formData.oilCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "所属期：" }
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyyMMdd",
                                  placeholder: "日期选择",
                                  clearable: false,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formData.dailyDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "dailyDate", $$v)
                                  },
                                  expression: "formData.dailyDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "进油吨数：" }
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入",
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.formData.totalGiveInTon,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "totalGiveInTon",
                                      $$v
                                    )
                                  },
                                  expression: "formData.totalGiveInTon"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "进油升数：" }
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入",
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.formData.totalGiveInLiters,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "totalGiveInLiters",
                                      $$v
                                    )
                                  },
                                  expression: "formData.totalGiveInLiters"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c("el-button", { on: { click: _vm.onClear } }, [_vm._v("清空")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }